<div class="emperor-ui-quote-presentation">
  <div class="muli-carrier-logo">
    <div class="emperor-ui-carrier-logo-container" *ngIf="carrierLogo">
      <img
        class="emperor-ui-carrier-logo"
        [src]="carrierLogo"
        [alt]="carrierName"
      />
      <emperor-icon
        *ngIf="logoIcon && !supplierLogo"
        [name]="logoIcon"
        [class]="logoIconColor"
      ></emperor-icon>
    </div>

    <ng-container *ngIf="supplierLogo">
      <div class="emperor-ui-vertical-divider"></div>

      <div class="emperor-ui-carrier-logo-container">
        <img
          class="emperor-ui-carrier-logo"
          [src]="supplierLogo"
          [alt]="supplierLogo"
        />
        <emperor-icon
          *ngIf="logoIcon"
          [name]="logoIcon"
          [class]="logoIconColor"
        ></emperor-icon>
      </div>
    </ng-container>
  </div>

  <div class="emperor-ui-quote-body">
    <div class="emperor-ui-quote-title">
      <h4>{{ headline }}</h4>
    </div>
    <div class="emperor-ui-quote-subtitle emperor-ui-subtext">
      <div *ngIf="quoteId">Quote ID: {{ quoteId }}</div>
      <div class="emperor-ui-subtext-details">
        <div class="emperor-ui-quote-carrier-name">
          {{ supplierName || carrierName }}
        </div>
        <ng-container *ngIf="subtitleText">
          <div>&nbsp;&#x2022;&nbsp;</div>
          <div class="emperor-ui-quote-detail">{{ subtitleText }}</div>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!ineligibleQuote; else ineligibleWarning">
    <div *ngIf="isLoading" class="spinner-container">
      <emperor-spinner
        [diameter]="42"
      ></emperor-spinner>
    </div>

    <div class="emperor-ui-quote-price-container">
      <div class="emperor-ui-price" *ngIf="price">
        <div class="emperor-ui-price-amount">
          <h4>
            ${{ price || '0' | displayPrice : 'dollars_and_cents' }}/{{
              costCycle
            }}
          </h4>
        </div>
      </div>
      <div class="emperor-ui-quote-primary-label">{{ quoteType }}</div>
    </div>

    <div class="emperor-ui-bind-info-container">
      <emperor-button
        *ngIf="showActionButton"
        (click)="onActionButtonClicked()"
        [disabled]="disableActionButton"
      >
        <div class="button-content">
          {{ displayButtonText }}
        </div>
      </emperor-button>
    </div>
  </ng-container>
</div>

<div class="emperor-ui-errors">
  <ng-content select="[errors]"></ng-content>
</div>

<div *ngIf="showViewDetails || showDownloadQuote" class="quote-detail-actions">
  <div class="quote-detail-actions-buttons">
    <emperor-button
      *ngIf="showDownloadQuote"
      class="download-quote"
      [uiButtonType]="emperorUiButtonType.Text"
      (click)="onDownloadQuoteClick()"
      >DOWNLOAD QUOTE</emperor-button
    >

    <emperor-button
      *ngIf="showViewDetails"
      [uiButtonType]="emperorUiButtonType.Text"
      class="view-details"
      (click)="onViewDetailsClicked()"
      >VIEW DETAILS</emperor-button
    >
  </div>
</div>

<ng-template #ineligibleWarning>
  <div class="emperor-ui-quote-warning">
    <emperor-icon
      name="interface_alert_circle_1"
      class="ineligible-icon"
    ></emperor-icon>
    <ng-content select="[ineligibleWarning]"></ng-content>
  </div>
</ng-template>
